import $ from "jquery";
import "slick-carousel";

const sliderLogoPartner = () => {
  const init = () => {
    exec();
  };

  const exec = () => {
    const el = {
      target: ".mi-logo-partner",
    };

    if ($(el.target).length === 0) return;

    $(document).ready(function () {
      $(el.target).slick({
        speed: 2000, // (ms)
        autoplay: true,
        autoplaySpeed: 1,
        centerMode: false,
        cssEase: "linear",
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        arrows: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        waitForAnimate: false,
        useCSS: false,
      });
    });
  };

  init();
};

try {
  sliderLogoPartner();
} catch (e) {
  console.error(e);
}
